import { render, staticRenderFns } from "./ErrorRegister.vue?vue&type=template&id=8bf852c4"
import script from "./ErrorRegister.vue?vue&type=script&lang=js"
export * from "./ErrorRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports